function getAIDAResults(image_key) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/aida-tools`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      image_key: `${image_key}`,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default getAIDAResults;
